import React from 'react';
import AdvertorialHeader from './components/AdvertorialHeader';
import AdvertorialContent from './components/AdvertorialContent';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import SidebarCTA from './components/SidebarCTA';
export function App() {
  return <div className="flex flex-col w-full min-h-screen bg-gray-50 pb-20" data-id="element-0">
      <div className="w-full bg-white shadow-sm" data-id="element-1">
        <AdvertorialHeader data-id="element-2" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-3">
          <div className="py-4 sm:py-6 lg:grid lg:grid-cols-12 lg:gap-8" data-id="element-4">
            <div className="lg:col-span-8" data-id="element-5">
              <AdvertorialContent data-id="element-6" />
            </div>
            <div className="hidden lg:block lg:col-span-4 lg:mt-6" data-id="element-7">
              <SidebarCTA data-id="element-8" />
            </div>
          </div>
        </div>
        <div className="mx-auto max-w-7xl" data-id="element-9">
          <Footer data-id="element-10" />
        </div>
      </div>
      <StickyCTA data-id="element-11" />
    </div>;
}